import { render, staticRenderFns } from "./Footer.vue?vue&type=template&id=cfe5e97a&scoped=true"
var script = {}
import style0 from "./Footer.vue?vue&type=style&index=0&id=cfe5e97a&prod&scoped=true&lang=less"
import style1 from "./Footer.vue?vue&type=style&index=1&id=cfe5e97a&prod&lang=less"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cfe5e97a",
  null
  
)

export default component.exports